// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1a_mD","cards":"styles-module--cards--M6e8q","card":"styles-module--card--1XfV8","border":"styles-module--border--1p0Ov"};